module.exports = __webpack_public_path__ + "static/media/leafy-preview.d998cfde.png";